
import { Image as ImageIcon, Video } from 'lucide-react';

import type { PlacementMedia } from './types';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.bmp', '.heic', '.avif'];

function isImage(media: PlacementMedia): boolean {
  const key = media.s3Key.toLowerCase();
  return IMAGE_EXTENSIONS.some((extension) => key.endsWith(extension));
}

interface Props {
  media: PlacementMedia | null;
  className?: string;
  controls?: boolean;
  size?: number;
}

export function MediaThumb({ media, className, controls = false, size = 16 }: Props) {
  const image = media ? isImage(media) : false;

  if (!media?.url) {
    return (
      <div className={className}>
        {image ? (
          <ImageIcon size={size} strokeWidth={1.3} />
        ) : (
          <Video size={size} strokeWidth={1.3} />
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      {image ? (
        <img src={media.url} alt={media.title} loading="lazy" />
      ) : (
        <video
          key={media.url}
          src={media.url}
          preload="metadata"
          muted
          playsInline
          controls={controls}
        />
      )}
    </div>
  );
}
